import constants from '../helpers/constants';

const MOBILE_FOOTER_ELEMENT = {
    menuFooter: 'mobile-menu-footer',
    menuWrapper: '.js-menu-nav',
    menuLink: '.js-nav-link',
    menuList: '.js-nav-list',
    activeClass: 'is-active',
};

/**
 * вернет список меню
 * @param link {HTMLElement}
 * @returns {*|boolean}
 */
function findMenuList(link) {
    const wrapper = link.closest(MOBILE_FOOTER_ELEMENT.menuWrapper);

    return wrapper ? wrapper.querySelector(MOBILE_FOOTER_ELEMENT.menuList) : false;
}

/**
 * открытия/закрытия подменю
 * @param e {Event}
 */
function handlerClick(e) {
    const link = e.currentTarget;
    const list = findMenuList(link);

    if (list) {
        link.classList.toggle(MOBILE_FOOTER_ELEMENT.activeClass);
        const listHeight = link.classList.contains(MOBILE_FOOTER_ELEMENT.activeClass)
            ? list.dataset.height
            : 0;
        list.style.height = `${listHeight}px`;
    }
}

/**
 * установит прослушку для ссылок
 * @param menuLinks {NodeList} - ссылки из меню
 */
function setListeners(menuLinks) {
    menuLinks.forEach((link) => {
        link.addEventListener('click', handlerClick);
    });
}

/**
 * установит дефолтную высоту для списка
 * @param list {HTMLElement} - список ссылок
 */
function setDefaultHeight(list) {
    list.style.height = 'auto';
    const listHeight = list.offsetHeight;
    list.setAttribute('data-height', listHeight);
    list.style.height = '0';
}

function resetMenu(menuList) {
    menuList.forEach((list) => {
        list.style.height = 'auto';
        const link = list.closest(MOBILE_FOOTER_ELEMENT.menuWrapper).querySelector(MOBILE_FOOTER_ELEMENT.menuLink);
        link.classList.remove(MOBILE_FOOTER_ELEMENT.activeClass);
    });
}

function mobileMenuFooter() {
    const menu = document.getElementById(MOBILE_FOOTER_ELEMENT.menuFooter);
    if (!menu) return false;

    const menuList = menu.querySelectorAll(MOBILE_FOOTER_ELEMENT.menuList);
    resetMenu(menuList);

    if (window.innerWidth > constants.mobileWidth) {
        return false;
    }
    menuList.forEach((list) => {
        setDefaultHeight(list);
    });

    const menuLinks = menu.querySelectorAll(MOBILE_FOOTER_ELEMENT.menuLink);
    if (!menuLinks) return false;

    setListeners(menuLinks);
}

export default mobileMenuFooter;
